// extracted by mini-css-extract-plugin
export default {"returnSection":"MerchantSiteRedirectButton_returnSection__t7s8K","autoRedirect":"MerchantSiteRedirectButton_autoRedirect__NbI09"};